export const Routes = {
  queueItem: "/",
  activityLog: "/activityLog",
};
